import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { StoresTable } from "./stores-table"
import { fetchPartnerStoresStatistics, selectCurrentPartner, selectEndDate, selectPartnerStoresStatisticsFirstLoad, selectStartDate, setEndDate, setSelectedPartner, setStartDate } from "../model"
import { useEffect, useRef } from "react"
import { StoresFilters } from "./stores-filters"

export const PartnerStoresPage = () => {
    const isFirstRender = useRef(true)
    const dispatch = useAppDispatch()
    const isFirstLoad = useAppSelector(selectPartnerStoresStatisticsFirstLoad)
    const startDate = useAppSelector(selectStartDate)
    const endDate = useAppSelector(selectEndDate)
    const partner = useAppSelector(selectCurrentPartner)

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchPartnerStoresStatistics())
        }
    }, [startDate, endDate, partner])

    useEffect(() => {
        if (isFirstLoad) {
            dispatch(fetchPartnerStoresStatistics())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="торговые точки" />
            <div className='flexbox'>
                <PageSubtitle title='список торговых точек' />
                <StoresFilters />
                <StoresTable />
            </div>
        </div>
    )
}